(function ($, Global) {
	var VeilleModel = function () {
		this.terms = null;
	}

	VeilleModel.prototype.addKeywords = function (terms, callback) {
		this.terms = terms;

		$.ajaxPost('/ajax/veilles/create', this.terms)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					success: callback || null
				})
			});
	}

    VeilleModel.prototype.subscribe = function () {
		var self = this;

        $.Topic('veille-new').subscribe($.proxy(self.addKeywords, self));
	}

	Global.VeilleModel = VeilleModel;
}(jQuery, window));